<template>
  <div :class="['modal', 'animated', show ? 'is-active' : '']">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <div class="notification is-danger" v-if="errorLogin">{{errorLogin}}</div>
        <div class="notification is-info" v-if="showPIN">{{messagePIN}}</div>
        <p :class="{'control': true, 'has-icon': true, 'is-loading': inProgress, 'is-danger': errors.has('email')}">
          <input name="email" id="email" class="input" type="email" placeholder="Email" v-model="login.user" v-validate data-vv-rules="required|email">
          <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
          <i class="fa fa-envelope"></i>
        </p>
        <p :class="{'control': true, 'has-icon': true, 'is-loading': inProgress}">
          <input name="password" class="input" type="password" placeholder="Password" v-model="login.password" v-validate data-vv-rules="required" @keyup.enter="singIn()">
          <i class="fa fa-lock"></i>
        </p>
        <p :class="{'control': true, 'has-icon': true, 'is-loading': inProgress}" v-if="showPIN">
          <input name="pin" class="input" type="pin" placeholder="PIN" v-model="login.pin" v-validate data-vv-rules="required" @keyup.enter="singIn()">
          <i class="fa fa-check"></i>
        </p>
      </section>
      <footer class="modal-card-foot">
        <a class="button is-info" @click="forgot">Forgot Password?</a>
        <a :class="{'button': true, 'is-primary': true, 'is-disabled': errors.any() || inProgress, 'is-loading': inProgress}" style="float: right;" @click="singIn">Login</a>
      </footer>
    </div>
  </div>
</template>

<script>
  import auth from '../../auth'
  export default {
    props: {
      card: Boolean,
      visible: Boolean
    },
    data () {
      return {
        show: true,
        title: 'Login',
        login: {
          user: '',
          password: '',
          pin: ''
        },
        errorLogin: null,
        inProgress: false,
        showPIN: false,
        messagePIN: ''
      }
    },
    mounted () {
      this.$nextTick(() => {
        document.body.appendChild(this.$el)
        // auth.logout(this, false)
        if (this.$route.query.hasOwnProperty('token')) {
          this.show = false
          auth.loginToken(this, this.$route.query.token)
        } else {
          window.localStorage.clear()
          window.sessionStorage.clear()
        }
        if (this.$route.query.hasOwnProperty('error')) {
          this.show = true
          this.errorLogin = this.$route.query.error
        }
      })
    },
    created () {

    },
    destroyed () {
      this.$el.remove()
    },
    methods: {
      afterLeave () {
        this.$destroy()
      },
      active () {
        this.show = true
      },
      deactive () {
        this.show = false
      },
      close () {
        this.deactive()
      },
      open () {
        this.active()
      },
      singIn () {
        this.$validator.validateAll().then((result) => {
          if (result) {
            // this.inProgress = true
            this.$http.post(this.$store.state.config.apiURL + '/login', this.login).then((response) => {
              if (response.body.pin) {
                this.showPIN = true
                this.messagePIN = response.body.message
                this.errorLogin = ''
              } else {
                auth.loginToken(this, response.body)
              }
            }, (response) => {
              this.showPIN = false
              this.messagePIN = ''
              this.login.pin = null
              this.errorLogin = response.body.message
              this.inProgress = false
            })
          }
        })
      },
      forgot () {
        this.$router.push({name: 'Forgot'})
      }
    },
    computed: {
      enterClass () {
        return `${this.transition}In`
      },

      leaveClass () {
        return `${this.transition}Out`
      }
    }
  }
</script>
<style lang="scss">
  .modal-card-foot {
    align-items: center;
    background-color: whitesmoke;
    display: block;
    flex-shrink: 0;
    justify-content: flex-start;
    padding: 20px;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// Index.vue?e2daa5fe